import Avatar from 'components/Avatar';
import UserName from 'components/Avatar/UserName';
import { FireModelType } from 'models/FireModel';
import { UserModelType } from 'models/UserModel';
import React from 'react';

interface FireDetailTopProps {
  fire: FireModelType;
  user: UserModelType;
}

const FireDetailTop: React.FC<FireDetailTopProps> = ({ fire, user }) => {
  return (
    <>
      <div className="fire-detail-screen__type">
        {fire.fire_strategy_icon && (
          <img
            src={fire.fire_strategy_icon}
            className="fire-detail-screen__type-icon"
          />
        )}
        {fire.fire_strategy}
      </div>

      <div className="fire-detail-screen__container">
        <div className="fire-detail-screen__user-icon">
          <Avatar
            name={<UserName user={user} />}
            initials={user.initials}
            imgUrl={user.smallAvatar}
            noColor={true}
          />
        </div>
        <div>
          <label className="fire-detail-screen__toggle">
            <input type="checkbox" hidden />
            <span className="fire-detail-screen__clamped-text">
              {fire.input}
            </span>
          </label>
        </div>
      </div>
    </>
  );
};

export default FireDetailTop;
